import React from 'react';
import clsx from 'clsx';

import { type ViewPageProps } from './ViewPage';
import { type SelectionProps } from '../../hooks/useSelection';
import type { PaginationType } from '../../hooks/usePagination';
import useSettings from '../../hooks/useSettings';

// eslint-disable-next-line import/no-cycle
import ViewList, { type ViewListProps } from './list/ViewList';
// import ViewGrid, { type ViewGridProps } from './grid/ViewGrid';
import ViewTable, { type ViewTableColumnsLayoutType } from './table/ViewTable';

export type ViewPageContentType =
	| { type: 'list'; itemLayout: ViewListProps['itemLayout']; id?: string }
	// | { type: 'grid'; itemLayout: ViewGridProps['itemLayout']; id?: string  }
	| { type: 'table'; getColumns: ViewTableColumnsLayoutType; id?: string };

export type ViewPageContentWrapperProps = {
	className?: string;
	module: string;
	content: ViewPageContentType;
	paginationProps?: PaginationType;
	refresh: boolean;
	updateRefresh: VoidFunction;
	selectionProps?: SelectionProps;
} & Pick<ViewPageProps, 'showFilters' | 'showExportButton'>;

export default function ViewPageContentWrapper(props: ViewPageContentWrapperProps) {
	const { settings, t } = useSettings(props.module);

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(state => !state);

	// LIST
	if (props.content.type === 'list') {
		return (
			<ViewList
				className={props.className}
				id={!props.paginationProps ? props.content.id : undefined}
				module={props.module}
				itemLayout={props.content.itemLayout}
				paginationProps={props.paginationProps}
				refresh={props.refresh !== undefined ? props.refresh : refresh}
				updateRefresh={props.updateRefresh !== undefined ? props.updateRefresh : updateRefresh}
				selectionProps={props.selectionProps}
				showFilters={props.showFilters}
				showExportButton={props.showExportButton}
			/>
		);
	}

	// GRID
	// if (props.content.type === 'grid') {
	// 	return (
	// 		<ViewGrid
	// 			className={props.className}
	// 			id={!props.paginationProps ? props.content.id : undefined}
	// 			module={props.module}
	// 			itemLayout={props.content.itemLayout}
	// 			paginationProps={props.paginationProps}
	// 			refresh={props.refresh !== undefined ? props.refresh : refresh}
	// 			updateRefresh={props.updateRefresh !== undefined ? props.updateRefresh : updateRefresh}
	// 			selectionProps={props.selectionProps}
	// 			showFilters={props.showFilters}
	// 			showExportButton={props.showExportButton}
	// 		/>
	// 	);
	// }

	// TABLE
	if (props.content.type === 'table') {
		const columns = props.content.getColumns({ settings, t, updateRefresh });

		return (
			<ViewTable
				className={clsx('border-0', props.className)}
				id={!props.paginationProps ? props.content.id : undefined}
				module={props.module}
				columns={columns}
				paginationProps={props.paginationProps}
				refresh={props.refresh !== undefined ? props.refresh : refresh}
				updateRefresh={props.updateRefresh !== undefined ? props.updateRefresh : updateRefresh}
				selectionProps={props.selectionProps}
				showFilters={props.showFilters}
				showExportButton={props.showExportButton}
			/>
		);
	}

	return <></>;
}
